import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FirebaseService } from 'src/app/services/firebase.service';
import { EliminarCotizacionEmpresaComponent } from '../../cotizaciones-empresa/eliminar-cotizacion-empresa/eliminar-cotizacion-empresa.component';

@Component({
  selector: 'app-eliminar-cotizacion-persona-natural',
  templateUrl: './eliminar-cotizacion-persona-natural.component.html',
  styleUrls: ['./eliminar-cotizacion-persona-natural.component.scss']
})
export class EliminarCotizacionPersonaNaturalComponent implements OnInit {

  deshabilitado: boolean;

  constructor(
    private fs: FirebaseService,
    private dialogRef: MatDialogRef<EliminarCotizacionEmpresaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  eliminarReserva(idCotizacion) {
    this.deshabilitado = true;
    this.fs.deleteCotizacionPersonaNatural(idCotizacion)
    .then(() => {
      this.dialogRef.close();
      this.snackBar.open('Cotización eliminada', 'CERRAR', {
        duration: 3000,
      });
    });
  }

  cancelar() {
    this.dialogRef.close();
  }

}
